module.exports = __webpack_public_path__ + "static/img/ET_1016.c913d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping/ET_1016.png
// module id = 470
// module chunks = 1